import type { CheckoutSkiAncillaryService, Services, ServiceType } from '@/scopes/checkout/domain/types'
import { createClothingServiceEvent } from '@/scopes/checkout/domain/analytics/index'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'

export function useClickFilterClothingService<K extends ServiceType>(service: Services[K] | null, description: string) {
  const { sendEvent } = useAnalytics()

  const sendClothingGenderFilterClickEvent = (value: string) => {
    if (!service)
      return

    sendEvent(
      createClothingServiceEvent({
        result: 'Change gender',
        type: value,
        description,
        element: 'clickable text',
      }),
    )
  }

  const sendClothingSizeFilterClickEvent = (value: string) => {
    if (!service)
      return

    sendEvent(
      createClothingServiceEvent({
        result: 'Change size',
        type: value,
        description,
        element: 'clickable text',
      }),
    )
  }

  const sendClothingOptionFilterClickEvent = (optionId: string) => {
    if (!service)
      return
    const { options } = service as CheckoutSkiAncillaryService
    const selectedOption = options[optionId]
    sendEvent(
      createClothingServiceEvent({
        result: 'Change clothing option',
        type: selectedOption.label,
        description,
        element: 'clickable text',
      }),
    )
  }

  return {
    sendClothingGenderFilterClickEvent,
    sendClothingSizeFilterClickEvent,
    sendClothingOptionFilterClickEvent,
  }
}
